import { Injectable } from 'angular-ts-decorators';

import { Subject, Observable } from 'rxjs';

/**
 * Service that expose $route events as streams
 */
@Injectable('routeStreams')
export class RouteStreams {
  private changeSuccessSubject: Subject<any>;
  private changeStartSubject: Subject<any>;
  private updateSubject: Subject<any>;

  public changeSuccess$: Observable<any>;
  public changeStart$: Observable<any>;
  public update$: Observable<any>;

  constructor(private $rootScope: ng.IRootScopeService) {
    'ngInject';

    this.changeSuccessSubject = new Subject<any>();
    this.changeStartSubject = new Subject<any>();
    this.updateSubject = new Subject<any>();

    $rootScope.$on('$routeChangeSuccess', (event, next) => {
      this.changeSuccessSubject.next(next);
    });

    $rootScope.$on('$routeChangeStart', (event, next) => {
      this.changeStartSubject.next(next);
    });

    $rootScope.$on('$routeUpdate', (event, previous) => {
      this.updateSubject.next(previous);
    });

    /**
     * stream that emits every time on $routeChangeSuccess
     */
    this.changeSuccess$ = this.changeSuccessSubject.asObservable();

    /**
     * stream that emits every time on $routeChangeSuccess
     */
    this.changeStart$ = this.changeStartSubject.asObservable();

    /**
     * stream that emits every time on $routeUpdate, with an object provided by
     * underlying {@link
     * https://docs.angularjs.org/api/ngRoute/service/$route#event-$routeUpdate
     * event}:
     */
    this.update$ = this.updateSubject.asObservable();
  }
}
